import { CellGroup, Cell } from 'vant'
import { mapState } from 'vuex'
import { formatDate } from 'Utils/dateUtil'

export default {
  name:'HtComplete',
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    ldButton: () => import('Common/ldButton'),
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
  },
  data() {
    return {
      mescroll: null, // mescroll实例对象
      data: {},
      mescrollDown: {
        callback: this.loadData,
      }
    }
  },
  mounted() {
    /**
     * 初始化数据
     */
    this.loadData()
  },
  created() { },
  computed: mapState({
    /**
     * 酒店详情数据模型
     */
    data_: (state) => state.ht.orderDetails
  }),
  methods: {
    mescrollInit (mescroll) {
      this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    loadData() {
      this.$api['htQuery/getHtNeedOrderDetail']({
        id: this.$route.query.xjdid
      }).then(res => {
        this.data = res.data
        this.data._rzrqweek = formatDate(this.data.rzrq).week
        this.data._ldrqweek = formatDate(this.data.ldrq).week
        this.$nextTick(() => { // 数据渲染成功后,隐藏下拉刷新的状态
          this.mescroll.endSuccess()
        })
      }).catch(() => {})
    }
  },
  watch: {}
}